import { render, staticRenderFns } from "./EditInspectionComponent.vue?vue&type=template&id=98d4556e"
import script from "./EditInspectionComponent.vue?vue&type=script&lang=js"
export * from "./EditInspectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports